type ItemsComparer<T> = (a: T, b: T) => boolean;

export const isInArray = <T>(arr: T[], item: T, itemsComparer: ItemsComparer<T>) => {
  return arr.some(arrItem => itemsComparer(arrItem, item));
};
